type NoResultsProps = {
  searchTerm: string;
};

export const NoResults = ({ searchTerm }: NoResultsProps) => {
  return (
    <div className="flex flex-col items-center justify-center p-5 text-text-gray text-center">
      <span className="material-symbols-outlined text-4xl mb-2.5 opacity-60">
        search_off
      </span>
      <p className="text-base font-sans m-0 font-normal leading-normal">
        「{searchTerm}」に一致するルールが見つかりませんでした
      </p>
    </div>
  );
};
